module.exports = __webpack_public_path__ + "img/product-icon2.3ff12b90.png";